// @flow
import { getCreator } from '../../http';
import environment from '../../environment';

export const endpoints = Object.freeze({
  GET_WISH_LISTS: `${environment.apiUrl}/wishlist/list`,
});

export const getWishListsApi = getCreator(fetch, endpoints.GET_WISH_LISTS);



// WEBPACK FOOTER //
// ./src/modules/wish-list-catalog/api.js